/* @flow */
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import setupCriteria from 'setup/utils/setupCriteria';
import type { RouterState } from 'lib/ReactRouterTypes';

async function requireSetup(nextState: RouterState, replaceWith: Function, callback: Function) {
  const user =
    (CurrentUser.isSignedIn() && CurrentUser.getUser()) ||
    (await AuthActions.checkLoggedInAndLoadAppData());

  if (!user) {
    callback();
    return;
  }

  const step = setupCriteria.getNextEligibleStep(user);

  // If we found an eligible setup step transition to it.
  // Otherwise if we are in /setup transition out of /setup
  // Otherwise do nothing and stay in the current route.
  if (step) {
    replaceWith(step);
  } else if (nextState.location.pathname.startsWith('/setup')) {
    replaceWith('/classes');
  }

  callback();
}

export default requireSetup;
